import { mediumFont } from "@app/styles";
import styled from "styled-components";

type Props = {
  disabled?: boolean;
};

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
`;

export const SignInContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;


export const ForgotPwdImage = styled.img`
position: absolute;
left: -100px;
top: 0;
height: 100%;
@media (max-width: 575px){
  height: unset;
  width: 100px;
  position: unset;
}
`

export const ForgotPwdContentWrapper = styled.div`
height: 100%;
display: flex;
flex-direction: column;
justify-content: center;
padding-left: 80px;
text-align: center;
@media (max-width: 575px){
  padding-left: 8px;
}
`

export const ForgotPwdMessage = styled.p`
font-size: 16px;
line-height: 1.5;
${mediumFont};
margin: 20px 0;
`